import {Text, View} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';

export interface FilterDisplayProps {
  displayedFilter: string;
  extraFilterCount: number;
}

const FilterDisplay: React.FC<FilterDisplayProps> = ({
  displayedFilter,
  extraFilterCount,
}) => {
  const theme = useTheme();
  const {tuna} = theme.colors as any;

  return (
    <View mt="12px" justifyContent="center">
      {displayedFilter.length > 0 && (
        <Text
          fontSize={2}
          fontFamily="heading"
          fontWeight={700}
          color={tuna}
          textTransform="uppercase">
          Filters Applied: {displayedFilter}
          {extraFilterCount > 0 && ` + ${extraFilterCount} more`}
        </Text>
      )}
    </View>
  );
};

export default FilterDisplay;
